import { AfterViewInit, Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { Configuration } from '../../../core/configuration/configuration';
import { A3LEmployeeAbsenteeismBase } from '../../../core/models/a3LEmployeeAbsenteeismBase.model';
import { A3LEmployeeAbsenteeismSummary } from '../../../core/models/a3LEmployeeAbsenteeismSummary.model';
import { AjusteVacaciones } from '../../../core/models/ajusteVacaciones.model';
import { PageList } from '../../../core/models/pageList.model';
import { Vacaciones } from '../../../core/models/vacaciones.model';
import { A3LEmployeeService } from '../../../core/services/a3LEmployee.service';
import { AjusteVacacionesService } from '../../../core/services/ajusteVacaciones.service';
import { VacacionesService } from '../../../core/services/vacaciones.service';
import { PeriodosBolsaVacacionesModel } from '../../../core/models/periodosBolsaVacaciones.model';
import { PeriodosVacacionesModel } from '../../../core/models/periodosVacaciones.model';


@Component({
  selector: 'app-periodos-vacaciones-detail',
  templateUrl: './periodos-vacaciones-detail.component.html',
  styleUrls: ['./periodos-vacaciones-detail.component.scss'],
  providers: [VacacionesService, A3LEmployeeService, AjusteVacacionesService]
})
export class PeriodosVacacionesDetailComponent implements AfterViewInit {

  panelIcon = 'insert_invitation'; // material icon
  panelTitle = 'Vacaciones';
  panelDescription = '';
  periodoVacaciones: Vacaciones;
  solicitudes: Array<PeriodosVacacionesModel> = new Array<PeriodosVacacionesModel>();

  selectedCompany: number;
  selectedYear: number;
  selectedEmployee: string;

  showSearchPanel: boolean = false;

  ajusteVacaciones:AjusteVacaciones;

  otros: number;

  loading: boolean = false;
  id: string;

  constructor(
    protected _ajusteVacacionesService: AjusteVacacionesService,
    protected _vacacionesService: VacacionesService,
    protected _a3LEmployeeService: A3LEmployeeService,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _messageDialog: MessageDialog,
    protected _location: Location
  ) { }

  obtenerVacaciones() {
    this.loading = true;
    this._route.params.subscribe(params => {

      this.id = params['id'] as string;

      if (this.id) {
        this._vacacionesService.getModel(this.id).subscribe(res => {
          this.periodoVacaciones = res;
          this.solicitudes = this.periodoVacaciones.PeriodosVacaciones;
          this.otros = this.periodoVacaciones && this.periodoVacaciones.Otros;
          // TODO: Obbtener las solicitudes de vacaciones del empleado.
          this._ajusteVacacionesService.getAllByCompanyEmployeeAndYear(this.periodoVacaciones.CodigoEmpresa, this.periodoVacaciones.CodigoTrabajador, this.periodoVacaciones.Ejercicio).subscribe(
            res => {
              this.ajusteVacaciones = res;

              this.otros = this.ajusteVacaciones && this.ajusteVacaciones.Ajuste;
            },
            error => console.error(error)
          );
          // this.obtenerSolicitudes();
          this.loading = false;
        },
          err => {
            this.loading = false;
            this._messageDialog.ShowException(err);
          });
      }
    });
  }

  // obtenerSolicitudes() {
  //   let params: HttpParams = new HttpParams();
  //   params = params.set("year", this.periodoVacaciones.Ejercicio.toString());

  //   this._a3LEmployeeService.getHolidays(this.periodoVacaciones.CodigoEmpresa, this.periodoVacaciones.CodigoTrabajador, this.periodoVacaciones.Ejercicio).subscribe((res: PageList<A3LEmployeeAbsenteeismBase>) => {
  //     this.solicitudes = (Object.assign(this.solicitudes, res));
  //   },
  //     error => {
  //       console.error(error);
  //     })
  // }

  goBack() {
    this._location.back();
  }

  ngAfterViewInit(): void {
    this.showSearchPanel = this._route.snapshot.routeConfig.path === Configuration.newPath;
    if (!this.showSearchPanel) {
      setTimeout(() => this.obtenerVacaciones());
    }
  }

  onButtonActualizarClick() {
    this._messageDialog.ShowQuestion("¿Confirma la actualización del campo otros?", "Atención").then(result => {
      if (result.value) {


        this._vacacionesService.actualizarAjuste(this.periodoVacaciones.CodigoEmpresa, this.periodoVacaciones.CodigoTrabajador, this.periodoVacaciones.Ejercicio, this.otros).subscribe(
          (res: A3LEmployeeAbsenteeismSummary)=> {
            if(res)
            {
              // console.log(res);
              this.periodoVacaciones.Suma = res.total;

              this._messageDialog.ShowMessage("Actualización realizada con éxito", "Correcto");
              //this.obtenerVacaciones();
            }
          },
          error => {
            console.error(error)
            this._messageDialog.ShowAlert("No se ha podido actualizar los datos en A3Equipo", "Error");
          }
        );

      }
    });

  }

  onButtonBuscarClick() {
    this.loading = true;
    this._vacacionesService.getAllByCompanyEmployeeAndYear(this.selectedCompany, this.selectedEmployee, this.selectedYear).subscribe(res => {
      if (res) {
        this.periodoVacaciones = res;
        this.solicitudes= this.periodoVacaciones.PeriodosVacaciones;
        //this.obtenerSolicitudes();
      }
      this.loading = false;
    },
      err => {
        this._messageDialog.ShowException(err);
        this.loading = false;
      });
  }

  disableButtonSolicitar(ngForm: NgForm): boolean {
    return false;
    //return this.bolsaVacaciones && this.bolsaVacaciones.Importe == 0 || !ngForm.form.valid;
  }

}
